import { render } from "./About.vue?vue&type=template&id=b99a4b04"
const script = {}
script.render = render

export default script